import { Injectable, OnDestroy } from '@angular/core'
import { UrlTree } from '@angular/router'
import { Observable, Subscription } from 'rxjs'
import { CanDeactivateDirective } from '../can-deactivate.directive'
import { TranslateService } from '@ngx-translate/core'
import { tap } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuardService  implements OnDestroy {
  dialogText: string = ''
  dialogTextSubscription: Subscription

  constructor(private readonly translate: TranslateService) {
    this.dialogTextSubscription = translate
      .get('GENERAL.UNSAVED_CHANGES')
      .pipe(
        tap(text => {
          this.dialogText = text
        }),
      )
      .subscribe()
  }

  ngOnDestroy(): void {
    this.dialogTextSubscription.unsubscribe()
  }

  canDeactivate(component: EditPage): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (component.pending) {
      return false
    } else if (component.formIsDirty) {
      return confirm(this.dialogText)
    } else {
      return true
    }
  }
}

export abstract class EditPage extends CanDeactivateDirective {
  formIsDirty: boolean = false
  pending: boolean = false

  override unloadNotification($event: any): void {
    if (this.formIsDirty) {
      $event.returnValue = true
    }
  }
}
